import React, { useState } from 'react';
import { newsStyles as ns } from '../../styles/newsStyles';
import { formatDateLabel, parseMarkdown, triggerCampaignMail } from '../../utils/newsHelpers';

const NewsCard = ({ item, userCities }) => {
  const [isOpen, setIsOpen] = useState(false);

  const renderLocations = () => {
    const locations = item.location.split(',').map(l => l.trim());
    return locations.map((loc, index) => {
      const isMatch = userCities.includes(loc.toLowerCase()) || loc.toLowerCase() === 'bolivia';
      return (
        <span key={index} className={isMatch ? "" : "text-msc-red"}>
          {loc}{index < locations.length - 1 ? ', ' : ''}
        </span>
      );
    });
  };

  return (
    <>
      <article onClick={() => setIsOpen(true)} className={ns.card}>
        <div className={ns.cardImgContainer}>
          <img src={item.imageURL} className={ns.cardImg} alt="" />
        </div>
        <div className={ns.cardContent}>
          <h4 className={ns.cardTitle}>{item.title}</h4>
          <p className={ns.cardCaption}>{item.caption}</p>
        </div>
      </article>

      {isOpen && (
        <div className={ns.modalOverlay} onClick={() => setIsOpen(false)}>
          <div className={ns.modalContainer} onClick={e => e.stopPropagation()}>
            <button className={ns.modalClose} onClick={() => setIsOpen(false)}>✕</button>
            <div className={ns.modalImgCol}>
              <img src={item.imageURL} className="w-full h-full object-cover" alt="" />
            </div>
            <div className={ns.modalInfoCol}>
              <header className="mb-6">
                <span className={ns.modalDate}>{formatDateLabel(item.starts_at, item.ends_at, true)}</span>
                <p className={ns.modalLoc}>{renderLocations()}</p>
              </header>
              <h3 className={ns.modalTitle}>{item.title}</h3>
              <div className={ns.modalScrollArea} dangerouslySetInnerHTML={parseMarkdown(item.caption)} />
              <footer className={ns.modalFooter}>
                <button onClick={() => triggerCampaignMail(item)} className={`${ns.btnBase} ${ns.btnBlue}`}>Entrar en Contacto</button>
                {item.contentURL && (
                  <button onClick={() => window.open(item.contentURL, '_blank')} className={`${ns.btnBase} ${ns.btnGreen}`}>Descargar Contenido</button>
                )}
              </footer>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NewsCard;